import { useSplitTreatments } from "@splitsoftware/splitio-react";
import { useCheckoutUI } from "../../../CheckoutUIProvider";
import CheckoutOptions from "./CheckoutOptions";
import { RetailerConnect } from "./RetailerConnect";
import { useAppSelector } from "@/redux/hooks";
import CheckoutOptionsV2 from "./CheckoutOptionsV2";

const AccountForCheckout = () => {
  const userProfile = useAppSelector((state) => state.userProfile);
  const { treatments } = useSplitTreatments({
    names: ["brandclub_guest_checkout"],
    attributes: {
      email: userProfile?.email ?? "",
    },
  });

  const experimentEnabled =
    treatments["brandclub_guest_checkout"].treatment === "experiment";

  const enabledGuestCheckout =
    treatments["brandclub_guest_checkout"].treatment === "on" ||
    experimentEnabled;

  const [state] = useCheckoutUI();
  const { checkoutIntent } = state.context;

  if (!enabledGuestCheckout) {
    return <RetailerConnect />;
  }

  if (checkoutIntent?.retailerConnection?.username) {
    return <RetailerConnect />;
  }

  if (experimentEnabled) {
    return <CheckoutOptionsV2 />;
  }

  return <CheckoutOptions />;
};

export default AccountForCheckout;
